import { createGlobalStyle } from 'styled-components'
import bullet from '../assets/images/bullet.svg'
import {
  secondary1,
  secondary2,
  tertiary,
  blue,
  neutral,
  primary,
  purple,
  red,
  yellow,
  background,
} from './Colors'
import { spacing } from './Rythms'

const GlobalStyles = createGlobalStyle`

  :root {
    // Font sizes
    --font-xxs: 12px;
    --font-xs: 14px;
    --font-sm: 16px;
    --font-base: 18px;
    --font-lg: 20px;
    --font-xl1: 24px;
    --font-xl2: 30px;
    --font-xl3: 36px;
    --font-xl4: 48px;
    --font-xl5: 60px;
    --font-xl6: 72px;

    // Colors
    --neutral90: ${neutral[90]};
    --neutral80: ${neutral[80]};
    --neutral70: ${neutral[70]};
    --neutral60: ${neutral[60]};
    --neutral50: ${neutral[50]};
    --neutral40: ${neutral[40]};
    --neutral30: ${neutral[30]};
    --neutral20: ${neutral[20]};
    --neutral10: ${neutral[10]};
    --neutral0: ${neutral[0]};

    --background20: ${background[20]};
    --background10: ${background[10]};
    --background0: ${background[0]};
    --white: #fff;

    --primary90: ${neutral[90]};
    --primary80: ${primary[80]};
    --primary70: ${primary[70]};
    --primary60: ${primary[60]};
    --primary50: ${primary[50]};
    --primary40: ${primary[40]};
    --primary30: ${primary[30]};
    --primary20: ${primary[20]};
    --primary10: ${primary[10]};
    --primary0: ${primary[0]};

    --secondary1-90: ${secondary1[90]};
    --secondary1-80: ${secondary1[80]};
    --secondary1-70: ${secondary1[70]};
    --secondary1-60: ${secondary1[60]};
    --secondary1-50: ${secondary1[50]};
    --secondary1-40: ${secondary1[40]};
    --secondary1-30: ${secondary1[30]};
    --secondary1-20: ${secondary1[20]};
    --secondary1-10: ${secondary1[10]};
    --secondary1-0: ${secondary1[0]};

    --secondary2-90: ${secondary2[90]};
    --secondary2-80: ${secondary2[80]};
    --secondary2-70: ${secondary2[70]};
    --secondary2-60: ${secondary2[60]};
    --secondary2-50: ${secondary2[50]};
    --secondary2-40: ${secondary2[40]};
    --secondary2-30: ${secondary2[30]};
    --secondary2-20: ${secondary2[20]};
    --secondary2-10: ${secondary2[10]};
    --secondary2-0: ${secondary2[0]};

    --tertiary90: ${tertiary[90]};
    --tertiary80: ${tertiary[80]};
    --tertiary70: ${tertiary[70]};
    --tertiary60: ${tertiary[60]};
    --tertiary50: ${tertiary[50]};
    --tertiary40: ${tertiary[40]};
    --tertiary30: ${tertiary[30]};
    --tertiary20: ${tertiary[20]};
    --tertiary10: ${tertiary[10]};
    --tertiary0: ${tertiary[0]};

    --radius-md: 10px;

    --border-light: 1px solid var(--neutral30);
    --border-dark: 1px solid var(--neutral90);

    --shadow-inset: inset 0 4px 0 0 var(--neutral10);

    --shadow-grey: 4px 4px 0 0 var(--neutral30);
    --shadow-colour: 4px 4px 0 0 var(--primary30);
    --shadow-pink: 4px 4px 0 0 var(--secondary1-20);
    --shadow-light: 4px 4px 0 0 var(--background20);
    --shadow-dark: 4px 4px 0 0 var(--neutral90);
    --shadow-dark-small: 2px 2px 0 0 var(--neutral90);
    --shadow-elevation-2: 0px 3px 6px rgba(0, 0, 0, 0.15), 0px 2px 4px rgba(0, 0, 0, 0.12);


    --text: var(--neutral90);

    --lightText: ${neutral[70]};
    --xLightText: ${neutral[60]};
    --bg: ${background[0]};
    --headerBg: ${background[0]};
    --darkOnlyBg: #fff;
    --lightBg: ${background[10]};
    --contentBg: ${background[10]};
    --darkerBg: ${background[20]};
    --headerBoxShadow: rgba(0, 0, 0, 0.15) 0 1px 4px;
    --link: ${primary[60]};
    --logoFill: ${neutral[100]};
    --hairline: ${neutral[30]};

  }

  html {
    box-sizing: border-box;
    background-color: var(--bg);
  }

  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: var(--text);
  }

  * {
    margin: 0;
    padding: 0;
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  a {
    text-decoration: none;
  }

  pre {
    white-space: pre-wrap;
    overflow-wrap: break-word;
    max-width: 500px;
    width: 100%;
  }

  .light-shadow{
    box-shadow: var(--shadow-light);
  }

  .dark-shadow {
    box-shadow: var(--shadow-dark);
    border: 1px solid var(--neutral90);
  }

  .radius-md {
    border-radius: var(--radius-md);
  }

  ul.list-content, ul.bulleted-list {
    list-style-image: url('${bullet}');
    margin-bottom: 2.5rem;

    li {
      margin-left: ${spacing[5]};
      line-height: 155%;
      padding-left: ${spacing[3]};
    }

    li + li {
      margin-top: ${spacing[4]};
    }
  }
 `

export default GlobalStyles
